module.exports = __webpack_public_path__ + "static/media/biscotti_2.b2d9f5f9.jpg";